import React, { useEffect, useState } from "react";

import Table from "../../../components/Table";
import Button from "../../../components/Button";
import { ModalDelete } from "../../../components/ModalDelete";
import ModalPaymentTerm, { USAGE_OPTIONS } from "../../../components/PaymentCondition/ModalPaymentTerm";

import api from "../../../services/api";
import { renderError } from "../../../helpers/errors";
import { canUseGestao, hasPermission } from "../../../services/auth";
import { describeInstallments } from "../../../components/PaymentCondition/helpers";

const getUsageLabel = usage => USAGE_OPTIONS.find(option => option.value === usage)?.label ?? usage;

export const PaymentTermsTab = () => {
    const [loading, setLoading] = useState(true);
    const [deleting, setDeleting] = useState(false);

    const [terms, setTerms] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [termToEdit, setTermToEdit] = useState(null);
    const [termToDelete, setTermToDelete] = useState(null);

    const canManage = hasPermission('payment_terms');

    useEffect(() => {
        getTerms();
    }, []);

    const getTerms = () => {
        setLoading(true);

        api.get(`/payment-term`).then(res => {
            setTerms(res.data.resources);
        }).catch(renderError).then(() => setLoading(false));
    };

    const openModal = term => {
        setTermToEdit(term);
        setShowModal(true);
    };

    const saved = () => {
        setShowModal(false);
        getTerms();
    };

    const deleteTerm = () => {
        setDeleting(true);

        api.delete(`/payment-term/${termToDelete.id}`).then(() => {
            setTermToDelete(null);
            getTerms();
        }).catch(renderError).then(() => setDeleting(false));
    };

    const rows = terms.map(term => ({
        data: [
            <>
                {term.name}
                {term.is_default && <span className="payment-conditions-badge">Padrão</span>}
            </>,
            describeInstallments(term.installments),
            getUsageLabel(term.usage),
            term.active ? 'Ativa' : 'Inativa',
        ],
        buttons: canManage ? [
            <Button type={`delete`} svg={`delete`} action={() => setTermToDelete(term)} />,
        ] : [],
        action: canManage ? () => openModal(term) : null,
    }));

    return (
        <>
            <ModalDelete
                show={termToDelete !== null}
                text={<p>Tem certeza que deseja apagar a condição <strong>{termToDelete?.name}</strong>? Se ela já foi usada em algum documento, inative em vez de apagar.</p>}
                action={deleteTerm}
                loading={deleting}
                close={() => setTermToDelete(null)}
            />
            <ModalPaymentTerm
                show={showModal}
                close={() => setShowModal(false)}
                term={termToEdit}
                saved={saved}
            />

            <div className="payment-conditions-toolbar">
                <p>
                    {canUseGestao()
                        ? 'Condições escolhidas no orçamento, no pedido e no pedido de compra. As parcelas viram os títulos do financeiro e as duplicatas da nota fiscal.'
                        : 'Condições escolhidas no orçamento e no pedido.'}
                </p>
                {canManage &&
                    <Button type={`primary`} size={`small`} svg={`plus-white`} text={`Nova condição`} action={() => openModal(null)} />
                }
            </div>
            <Table
                header={['Nome', 'Parcelas', 'Usar em', 'Situação', ...(canManage ? [''] : [])]}
                rows={rows}
                loading={loading}
            />
        </>
    );
};

export default PaymentTermsTab;
